/* @flow */
import Collection from 'lib/Collection';
import GroupMembership from 'entities/GroupMembership';
import Subscribers from 'collections/Subscribers';

class GroupMemberships extends Collection {
  initialize() {
    this.url = '/members';
    this.model = GroupMembership;
  }

  comparator(a: GroupMembership, b: GroupMembership) {
    const nameA = a.getUser().getFirstName();
    const nameB = b.getUser().getFirstName();
    return nameA.localeCompare(nameB);
  }

  sortByFirstName() {
    return this.sortBy(member => {
      const user = member.getUser();
      return `${user.getFirstName()} ${user.getLastName()}`.toLowerCase();
    });
  }

  sortByLastName() {
    return this.sortBy(member => {
      const user = member.getUser();
      return `${user.getLastName()}, ${user.getFirstName()}`.toLowerCase();
    });
  }

  sortByCreatedAt() {
    return this.sortBy(member => -member.getCreatedAt());
  }

  sortByOrganizationRole() {
    return this.sortBy(member => {
      const orgAffView = member.getOrgAffiliationView();
      return orgAffView ? orgAffView.roles.join(',') : '';
    });
  }

  groupByRole() {
    const members = this.groupBy('role');
    return new GroupMemberships(
      [].concat(
        members['owner'] || [],
        members['subscriber'] || []
      ),
      { sort: false }
    );
  }

  getSubscribers() {
    return new Subscribers(this.map(member => member.getUser()));
  }
}

export default GroupMemberships;



// WEBPACK FOOTER //
// ./src/collections/GroupMemberships.js